import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Site survey & floor audit",
    desc: "We evaluate your breakroom footprint, foot traffic and electrical specs — zero obligation.",
  },
  {
    n: "02",
    title: "Tailored equipment & menu",
    desc: "Choose full vending, a micro market or a coffee bar, with a custom product menu for your team.",
  },
  {
    n: "03",
    title: "Free delivery & installation",
    desc: "Certified technicians set up, calibrate temperature and activate telemetry — at $0 cost.",
  },
  {
    n: "04",
    title: "AI restocking & 24/7 service",
    desc: "Sensors dispatch us before items run out. Guaranteed same-day maintenance response.",
  },
];

export default function Process() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="text-center">
          <div className="flex justify-center">
            <Eyebrow>How it works</Eyebrow>
          </div>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-[#16120E] sm:text-4xl lg:text-5xl">
            From empty corner to full breakroom in days.
          </h2>
        </Reveal>

        <div className="relative mt-16 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div
            aria-hidden="true"
            className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-[#C9A227]/70 to-transparent lg:block"
          />
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div className="group relative" data-testid={`process-step-${i + 1}`}>
                <div className="relative z-10 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-[#1B365D]/30 bg-white font-mono text-sm font-semibold text-[#1B365D] transition-all duration-300 group-hover:border-[#1B365D] group-hover:bg-[#1B365D] group-hover:text-[#FBF7EF]">
                  {s.n}
                </div>
                <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-[#16120E] sm:text-xl">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-500">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
